<template>
  <i v-if="loading" class="fas fa-sync fa-7x fa-spin"></i>
  <div v-else>
    <time-line type="simple">
      <time-line-item
        v-for="(version, key) in versions"
        :key="key"
        inverted
        badge-type="info"
        badge-icon="nc-icon nc-spaceship"
      >
        <badge slot="header" type="info">{{ version.version }}</badge>
        <h6 slot="footer">
          <i class="far fa-clock"></i>
          {{ version.formatedDate }}
        </h6>
      </time-line-item>
    </time-line>
  </div>
</template>

<script>
import { TimeLine, TimeLineItem, Badge } from "src/components/UIComponents";

export default {
  components: {
    TimeLine,
    TimeLineItem,
    Badge
  },
  data() {
    return {
      versions: [],
      loading: true
    };
  },
  created() {
    this.$http
      .get("/api/v1/gitVersion")
      .then(({ data }) => {
        this.versions = data;
      })
      .finally(() => {
        this.loading = false;
      });
  }
};
</script>
